module.exports = "https://static.wanderu.com/static/media/wanderu_exclusive_small_peek-horizontal_prod.07dc3c64.png";